import Dexie from 'dexie'

export interface ITranscriptLog {
	id: number
	targetId: string
	startedAt: number
	text: string
	analysis?: string
	similarities?: string[]
}

class ScribeDB extends Dexie {
	transcriptLog: Dexie.Table<ITranscriptLog, number>

	constructor() {
		super('intuizen-scribe-db')

		// Only columns that are indexed need to be specified here
		this.version(1).stores({
			transcriptLog: '++id, targetId, startedAt',
		})

		this.transcriptLog = this.table('transcriptLog')
	}

	async logTranscript(transcriptData: ITranscriptLog): Promise<number> {
		try {
			const id = await this.transcriptLog.add(transcriptData)
			return id
		} catch (error) {
			throw error
		}
	}

	async clearTranscriptLogsForTarget(targetId: string): Promise<void> {
		try {
			await this.transcriptLog.where({ targetId }).delete()
		} catch (error) {
			console.error('Error clearing transcript logs:', error)
			throw error
		}
	}

	async updateTranscriptRecord(
		id: number,
		analysis: string,
		similarities: string[],
	): Promise<void> {
		try {
			await this.transcriptLog.update(id, {
				analysis,
				similarities,
			})
		} catch (error) {
			console.error('Error updating transcript record:', error)
			throw error
		}
	}

	async getTranscriptLogsForTarget(
		targetId: string,
	): Promise<ITranscriptLog[]> {
		return this.transcriptLog.where({ targetId }).toArray()
	}
}

const db = new ScribeDB()
export default db
